<template>
    <div class="flex justify-strech items-center">
        <div class="px-4 text-gray-900 text-left w-35%">
          {{description}}
          <span v-if="is_refund" class="text-sm font-medium bg-red-100 py-1 px-2 rounded text-red-500 align-middle ml-2">
            Auslage
          </span>
        </div>
        <div class="px-4 text-gray-900 text-right w-5%">
          {{factor | toFloat(1,2)}}
          <div v-if="use_old_rvg" class="bg-red-400 text-xs text-white text-center py-0 px-2 rounded">alt</div>
        </div>
        <div class="px-4 text-gray-900 text-right w-15%">{{jurisdictional_amount | toCurrency}}</div>
        <div class="px-4 text-gray-900 text-right w-10%">{{amount | toCurrency}}</div>
        <div class="px-4 text-gray-900 text-right w-5%">{{sales_tax_percent}}%</div>
        <div class="px-4 text-gray-900 text-right w-10%">{{amount_with_tax() | toCurrency}}</div>
        <div class="px-4 text-center w-20%">
            <button v-on:click="$emit('edit')" class="btn btn-small btn-secondary mr-4">
                <i class="fas fa-edit"></i> bearbeiten
            </button>
            <button v-on:click="this.delete" class="btn btn-small btn-remove">
                <i class="far fa-trash-alt"></i> löschen
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: ['description', 'factor', 'jurisdictional_amount', 'amount', 'sales_tax_percent', 'is_refund', 'use_old_rvg'],
        data() {
            return {
                confirmDelete: false,
            }
        },
        filters: {
            toFloat: function(value, decimals = 2, minDecimals = 0) {
                if (value == null) {
                    return value;
                }
                const num = parseFloat(value);
                if (isNaN(num)) {
                    return value;
                }
                return num.toFixed(Math.max(decimals, minDecimals));
            },
            toCurrency: function(value) {
                if (typeof value !== "number") {
                    return value;
                }
                var formatter = new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR',
                });
                return formatter.format(value);
            }
        },
        methods: {
            amount_with_tax: function () {
                return this.amount + (this.amount * this.sales_tax_percent / 100);
            },
            delete: function () {
                this.$confirm(
                    {
                        message: `Wirklich löschen? 🔥`,
                        button: {
                            no: 'Abbrechen',
                            yes: 'Löschen'
                        },
                        /**
                         * Callback Function
                         * @param {Boolean} confirm
                         */
                        callback: confirm => {
                            if (confirm) {
                                this.$emit('delete')
                            }
                        }
                    }
                )
            }
        }
    }
</script>